import React from "react";
import styled from "styled-components";

import { VSpace } from "@examspark/common-ui/server";

const Legend = styled.div`
  border-top: solid 2px crimson;
  border-bottom: solid 2px crimson;
  padding: 1rem;
  color: #333;
  font-size: 1.3rem;
  line-height: 1.5em;
`;

const LegendTitle = styled.h4`
  font-weight: normal;
  color: #777;
  text-transform: uppercase;
`;

export const VerificationSectionRow = styled.tr`
  position: sticky;
  top: var(--top);
  z-index: 2;
  td {
    font-weight: 600;
    background-color: #f0f0f0;
  }
`;

export const VerificationTable = styled.table`
  --top: 6rem;
  box-sizing: border-box;
  border-collapse: collapse;

  th {
    color: #431f99;
    font-weight: 500;
    padding: 1rem 1rem;
    font-size: 1.1rem;
  }

  td {
    border: solid 1px #ddd;
    padding: 1rem;
    line-height: 1.7rem;
    color: #333;
    font-size: 1.3rem;

    span {
      margin-right: 0.5rem;
    }
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 2;

    th {
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(2px);
      border-bottom: solid 2px #ddd;
      height: var(--top);
    }
  }
`;

export const VerificationLegend = styled(() => (
  <Legend>
    <VSpace>
      <div>
        <LegendTitle>Legend</LegendTitle>
      </div>
      <VSpace size="0.5rem">
        <div>
          <strong>T - Taught Directly:</strong> TEKS intended to be explicitly
          taught in this unit.
        </div>
        <div>
          <strong>D - Developing:</strong> TEKS that need continued practice,
          improvement, and refinement, but do not necessarily need to be
          explicitly taught in this unit.
        </div>
        <div>
          <strong>O - Ongoing:</strong> TEKS that have been previously taught
          where proficiency of the knowledge/skill is evident, and the
          knowledge/skill is intended to be applied or practiced in a new or
          different context.
        </div>
      </VSpace>
    </VSpace>
  </Legend>
))``;
